import { FEATURE_FLAGS } from '@vizit/constants';
import { useFeatureFlag } from './use-feature-flag';

/**
 * Returns whether custom benchmarks should be shown.
 *
 * Defaults to `false`: the Library Collections tab renders exactly as it did
 * before benchmarks existed until the flag is explicitly enabled.
 */
function useShowCustomBenchmarks(): boolean {
  return useFeatureFlag(FEATURE_FLAGS.CUSTOM_BENCHMARKS_FE, false);
}

export { useShowCustomBenchmarks };
